import type { App, DataApp } from '../IntegrationsRecommendation.types'
import { APPS_MAP } from '../constants'

export const mapApp = (app: DataApp): App => ({
  flag: APPS_MAP[app.app].flag,
  connected: app.status !== 'NOT_CONNECTED',
  thumbnail: APPS_MAP[app.app].thumbnail,
  signet: APPS_MAP[app.app].signet,
  name: APPS_MAP[app.app].name || app.app,
  description: APPS_MAP[app.app].description,
  to: APPS_MAP[app.app].to,
  docs: APPS_MAP[app.app].docs,
})
